
import axios from 'axios';
import apiUrl from 'config/api';

import {
  FETCH_QUESTION,
  FETCH_QUESTION_SUCCESS,
  FETCH_QUESTION_FAIL,
  SEND_ANSWER,
  SEND_ANSWER_SUCCESS,
  SEND_ANSWER_FAIL,
  ASK_QUESTION,
  ASK_QUESTION_SUCCESS,
  ASK_QUESTION_FAIL,
  CLEAN_QUESTION
} from 'config/types';

export const fetchQuestion = (id, {onSuccess}) => dispatch => {
  dispatch({ type: FETCH_QUESTION });

  return axios({
    method: 'GET',
    url: `${apiUrl}/question/${id}`,
  })
    .then(({ data }) => dispatch({ type: FETCH_QUESTION_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: FETCH_QUESTION_FAIL, error }));
};

export const sendAnswer = (id, serieId, data, {onSuccess}) => dispatch => {
  dispatch({ type: SEND_ANSWER });

  return axios({
    method: 'POST',
    url: `${apiUrl}/question/${id}?serie=${serieId}`,
    data: data
  })
    .then(({ data }) => dispatch({ type: SEND_ANSWER_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: SEND_ANSWER_FAIL, error }));
};

export const askQuestion = (data) => dispatch => {
  dispatch({ type: ASK_QUESTION });

  return axios({
    method: 'POST',
    url: `${apiUrl}/query`,
    data: data
  })
    .then(({ data }) => dispatch({ type: ASK_QUESTION_SUCCESS, payload: data }))
    .catch(error => dispatch({ type: ASK_QUESTION_FAIL, error }));
};


export const cleanQuestion = (id) => dispatch => {
  dispatch({ type: CLEAN_QUESTION });
}